import request from '@/utils/request'

// 导入用户

let PointsCateApi = {

    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/user.points_cate/index', data, errorback);
    },

    /*添加*/
    add(data, errorback) {
        return request._post('/shop/user.points_cate/add', data, errorback);
    },

    /*删除*/
    del(data, errorback) {
        return request._post('/shop/user.points_cate/del', data, errorback);
    },

    /*编辑*/
    edit(data, errorback) {
        return request._post('/shop/user.points_cate/edit', data, errorback);
    },
}

export default PointsCateApi;



// WEBPACK FOOTER //
// ./src/api/study/points_cate.js